import validateCheckbox from './checkbox'
import validateInput from './input'
import validateRadio from './radio'
import validateSelect from './select'
import validateTextarea from './textarea'

const validators = {
  checkbox: validateCheckbox,
  input: validateInput,
  radio: validateRadio,
  select: validateSelect,
  textarea: validateTextarea,
}

const union = (setA, setB) => {
  const newSet = new Set(setA)
  setB.forEach(e => newSet.add(e))
  return newSet
}

export default (page, { answer = {} }) =>
  page.page_elements.filter(
    pe => validators[pe.question_type],
  ).map(pe =>
    validators[pe.question_type](pe, answer),
  ).reduce((x, y) => ({
    valid: x.valid && y.valid,
    is_correct_answer: x.is_correct_answer && y.is_correct_answer,
    errors: union(x.errors, y.errors),
  }), {
    valid: true,
    is_correct_answer: true,
    errors: new Set(),
  })



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/validators/Form/index.jsx